<template>
    <header ref="siteHeader" class="header">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-auto d-xxl-none">
                    <button :class="['burger-button',{'burger-button--open': drawerOpen}]" @click.prevent="toggleDrawer()" title="Toggle Navigation" type="button" >
                        <svg xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 -960 960 960" width="32">
                            <path d="M140.001-254.616v-59.999h679.998v59.999H140.001Zm0-195.385v-59.998h679.998v59.998H140.001Zm0-195.384v-59.999h679.998v59.999H140.001Z"/>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 -960 960 960" width="32">
                            <path d="M256-213.847 213.847-256l224-224-224-224L256-746.153l224 224 224-224L746.153-704l-224 224 224 224L704-213.847l-224-224-224 224Z"/>
                        </svg>
                    </button>
                </div>
                <div class="col-auto ml-auto mr-auto">
                    <a href="/" class="header__logo logo" aria-label="Go to home page">
                        <slot name="sitelogo"></slot>
                    </a>
                </div>
                <div class="col-auto order-xxl-last">
                    <div class="button-list">
                        <slot name="buttons"></slot>
                        <button class="svg-button svg-button--basket" @click="goToBasket()"  title="Go to basket" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 -960 960 960"><path d="M221-120q-27 0-48-16.5T144-179L42-549q-5-19 6.5-35T80-600h190l176-262q5-8 14-13t19-5q10 0 19 5t14 13l176 262h192q20 0 31.5 16t6.5 35L816-179q-8 26-29 42.5T739-120H221Zm-1-80h520l88-320H132l88 320Zm260-80q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM367-600h225L479-768 367-600Zm113 240Z"/></svg>
                            <span class="d-none d-xxl-block">Basket</span>
                            <BasketCounter class="basket-items"></BasketCounter>
                        </button>
                    </div>
                </div>
                <div class="col-12 col-xxl mb-2 mb-xxl-0">
                    <SearchBar 
                        :product-search-title="productSearchTitle"
                        :pages-search-title="pagesSearchTitle"
                        :no-results-text="noResultsText"
                        :initial-search-results="initialSearchResults"
                        :rootId="rootId"
                    />
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col-auto d-xxl-none">
                    <div v-if="showMobileNav" class="off-canvas">
                        <div :class="['off-canvas__drawer',{'off-canvas__drawer--open': drawerOpen}]" :style="{top: drawerPadding}">
                            <div class="container">
                                <div class="mobile-nav">
                                    <ul class="mobile-nav__items">
                                        <li v-for="item of navigationData" :key="item.id" class="mobile-nav__item">
                                            <div class="mobile-nav__control">
                                                <a class="mobile-nav__link" :href="item.url" :target="item.target">
                                                    {{ item.name }}
                                                </a>
                                                <button v-if="hasSubNav(item)" :class="['mobile-nav__toggle',{'mobile-nav__toggle--rotated': selectedSubMenus.find(menuId => menuId === item.id + 1 )}]" @click="toggleSubMenu(item.id + 1)">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
                                                        <path d="M480-371.923 267.692-584.231 296-612.539l184 184 184-184 28.308 28.308L480-371.923Z"/>
                                                    </svg>
                                                </button>
                                            </div>
                                            <template v-if="hasSubNav(item)">
                                                <div :class="['mobile-nav__submenu',{'mobile-nav__submenu--open': selectedSubMenus.find(menuId => menuId === item.id + 1 )}]">
                                                    <ul v-for="(subNav, index) in item.subNavigation" :key="index" class="mobile-nav__sub-items">
                                                        <li v-if="subNav.title" class="mobile-nav__sub-label">
                                                            <a v-if="subNav.feature" :href="subNav.feature.url" :target="subNav.feature.target">
                                                                {{ subNav.title }}
                                                            </a>
                                                            <template v-else>
                                                                {{ subNav.title }}
                                                            </template>
                                                        </li>
                                                        <li v-for="subItem of subNav.items" class="mobile-nav__sub-item" :key="subItem.id">
                                                            <a class="mobile-nav__sub-link" :href="subItem.url" :target="subItem.target">
                                                                {{ subItem.name }}
                                                            </a>
                                                            <template v-if="subItem.featured">
                                                                <span class="mega-nav__featured-badge badge badge--pink">HOT</span>
                                                            </template>
                                                        </li>
                                                        <li v-if="subNav.feature" class="mobile-nav__sub-item mobile-nav__sub-item--feature">
                                                            <a class="mobile-nav__sub-link" :href="subNav.feature.url" :target="subNav.feature.target">
                                                                <span>{{ subNav.feature.name }}</span>
                                                                <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20">
                                                                    <path d="M262.771-210.001 460.719-480 262.771-749.999h61.742L522.461-480 324.513-210.001h-61.742Zm241.692 0L702.411-480 504.463-749.999h61.742L764.153-480 566.205-210.001h-61.742Z"/>
                                                                </svg>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </template>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div v-if="showMegaNav" class="mega-nav" role="navigation" aria-label="Main">
                        <ul class="mega-nav__items">
                            <li v-for="item in navigationData" :key="item.id" :class="['mega-nav__item',{'mega-nav__item--has-dropdown': hasSubNav(item)}]" @mouseenter="updateActiveSubItem(getRandomSubNavItem(item), null)" @mouseleave="resetActiveSubItem">
                                <a class="mega-nav__link" :href="item.url" :target="item.target">
                                    {{ item.name }}
                                </a>
                                <template v-if="hasSubNav(item) && item.subNavigation.length > 1">
                                    <div class="mega-nav__sub-nav-wrapper mega-nav__sub-nav-wrapper--mega">
                                        <div class="container">
                                            <div :class="['mega-nav__sub-nav', item.subNavigation.length > 1 ? 'mega-nav__sub-nav--columns' : '']" :style="[item.subNavigation.length > 1 ? '--mega-menu-columns:' + item.subNavigation.length : '']">
                                                <ul v-for="(subNav, index) in item.subNavigation" :key="index" class="mega-nav__sub-items">
                                                    <li v-if="subNav.title" class="mega-nav__sub-label">
                                                        <template v-if="subNav.feature">
                                                            <a :href="subNav.feature.url" :target="subNav.feature.target">
                                                                {{ subNav.title }}
                                                                <!-- <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><path d="M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"/></svg> -->
                                                            </a>
                                                        </template>
                                                        <template v-else>
                                                            {{ subNav.title }}
                                                        </template>
                                                    </li>
                                                    <li v-if="subNav.image" class="mega-nav__sub-image">
                                                        <a v-if="subNav.feature" :href="subNav.feature.url" :target="subNav.feature.target">
                                                            <img :width="subNav.image.width" :height="subNav.image.height" :src="subNav.image.url" :alt="subNav.image.altText">
                                                        </a>
                                                        <template v-else>
                                                            <img :width="subNav.image.width" :height="subNav.image.height" :src="subNav.image.url" :alt="subNav.image.altText">
                                                        </template>
                                                    </li>
                                                    <li v-for="subItem of subNav.items" :class="['mega-nav__sub-item', subItem.featured ? 'mega-nav__sub-item--featured' : '']"  :key="subItem.id">
                                                        <a :class="['mega-nav__sub-link',{'active': pageUrl && pageUrl == subItem.url}]" :href="subItem.url" :target="subItem.target">
                                                            {{ subItem.name }}
                                                        </a>
                                                        <template v-if="subItem.featured">
                                                            <span class="mega-nav__featured-badge badge badge--pink">HOT</span>
                                                        </template>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else-if="hasSubNav(item) && item.subNavigation.length <= 1">
                                    <div class="mega-nav__sub-nav-wrapper mega-nav__sub-nav-wrapper--dropdown">
                                        <div class="mega-nav__sub-nav mega-nav__sub-nav--list">
                                            <ul v-for="(subNav, index) in item.subNavigation" :key="index" class="mega-nav__sub-items">
                                                <li v-if="subNav.title" class="mega-nav__sub-label">
                                                    <a v-if="subNav.feature" :href="subNav.feature.url" :target="subNav.feature.target" @mouseenter="updateActiveSubItem(subNav.feature, subNav.image)">
                                                        {{ subNav.title }}
                                                    </a>
                                                    <template v-else>
                                                        {{ subNav.title }}
                                                    </template>
                                                </li>
                                                <li v-for="subItem of subNav.items" class="mega-nav__sub-item" :key="subItem.id">
                                                    <a class="mega-nav__sub-link" :href="subItem.url" :target="subItem.target" @mouseenter="updateActiveSubItem(subItem, null)">
                                                        {{ subItem.name }}
                                                    </a>
                                                </li>
                                                <li v-if="subNav.feature" class="mega-nav__sub-item mega-nav__sub-item--feature">
                                                    <a class="mega-nav__sub-link" :href="subNav.feature.url" :target="subNav.feature.target" @mouseenter="updateActiveSubItem(subNav.feature, subNav.image)">
                                                        <span>{{ subNav.feature.name }}</span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20">
                                                            <path d="M262.771-210.001 460.719-480 262.771-749.999h61.742L522.461-480 324.513-210.001h-61.742Zm241.692 0L702.411-480 504.463-749.999h61.742L764.153-480 566.205-210.001h-61.742Z"/>
                                                        </svg>
                                                    </a>
                                                </li>
                                            </ul>
                                            <ul class="mega-nav__sub-items" v-if="activeSubItem && activeSubItem.image">
                                                <li class="mega-nav__sub-image">
                                                    <a class="mega-nav__sub-link" :href="activeSubItem.url" :target="activeSubItem.target">
                                                        <img width="212" height="212" :src="activeSubItem.image.url" :alt="activeSubItem.image.altText" class="image-aspect-ratio image-aspect-ratio--1-1">
                                                        <p class="text-small">{{ activeSubItem.name }}</p>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </template>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import { toggleScroll } from '../../_helpers';
import SearchBar from '../components/SearchBar.vue';
import BasketCounter from '../components/BasketCounter.vue';

export default {
    name: 'site-header',
    data() {
        return {
            drawerOpen: false,
            drawerReady: false,
            drawerPadding: '0px',
            selectedSubMenus: [],
            subNavigation: [],
            pageUrl: '',
            showMobileNav: false,
            showMegaNav: false,
            activeSubItem: null,
        };
    },
    props: {
        navigationData: {
            type: Array,
            required: true,
            default: () => []
        },
        basketItems: {
            type: Number,
            default: 0
        }, 
        basketUrl: {
            type: String,
            required: false,
            default: '/basket/'
        },
        productSearchTitle: {
            type: String,
            default: 'Products'
        },
        pagesSearchTitle: {
            type: String,
            default: 'Other Pages'
        },
        noResultsText: {
            type: String,
            default: '<p>Nothing matched your search query, please try again</p>'
        },
        initialSearchResults: {
            type: Object,
            default: () => ({ products: [], pages: [] })
        },
        rootId: {
            type: Number,
            required: true
        }
    },
    components: {
        SearchBar,
        BasketCounter
    },
    methods: {
        getRandomSubNavItem(item) {
            if (item.subNavigation && item.subNavigation.length > 0) {
                const subNav = item.subNavigation[0];

                if(subNav && subNav.items.length > 0) {
                    const randomIndex = Math.floor(Math.random() * subNav.items.length);
                    return subNav.items[randomIndex];
                }
            }
            return null;
        },
        updateActiveSubItem(subItem, subImage) {

            if (subImage !== null) {
                subItem.image = subImage;
            }

            this.activeSubItem = { ...subItem };
        },
        resetActiveSubItem() {
            this.activeSubItem = null; 
        },
        checkScreenWidth() {
            // Determine whether to show mobile navigation based on screen width
            this.showMobileNav = window.innerWidth < 1400;
            this.showMegaNav = window.innerWidth >= 1400;
        },
        hasSubNav(item) {
            return item.subNavigation && item.subNavigation.length > 0;
        },
        getDrawerPadding() {
            this.drawerPadding = this.$refs.siteHeader.getBoundingClientRect().bottom + 'px';
        },
        setHeaderHeightCssVar() {
            document.documentElement.style.setProperty('--header-height', `${this.$refs.siteHeader.getBoundingClientRect().bottom + 'px'}`); 
        },
        toggleDrawer() {
            this.getDrawerPadding();
            this.drawerReady = !this.drawerReady;
            setTimeout(() => {  
                this.drawerOpen = !this.drawerOpen;
            }, 100);
            toggleScroll();
        },
        toggleSubMenu(id) {
            if(this.selectedSubMenus.includes(id)) {
                this.selectedSubMenus = this.selectedSubMenus.filter(menuId => menuId !== id);
            } else {
                this.selectedSubMenus.push(id);
            }
        },
        goToBasket() {
            window.location.href = this.basketUrl;
        },
    },
    mounted() {
        this.pageUrl = window.location.pathname;
        this.checkScreenWidth();
        this.setHeaderHeightCssVar();
        this.getDrawerPadding();

        window.addEventListener('resize',() => {
            this.getDrawerPadding();
            this.setHeaderHeightCssVar();
            this.checkScreenWidth();
        });

        window.addEventListener('orientationchange',() => {
            this.checkScreenWidth();
            this.setHeaderHeightCssVar();
            this.getDrawerPadding();
        });
    },
    updated() {
        this.setHeaderHeightCssVar();
    }, 
    beforeUnmount() {
        window.removeEventListener('resize', this.checkScreenWidth);
        window.removeEventListener('resize', this.getDrawerPadding);
        window.removeEventListener('resize', this.setHeaderHeightCssVar);
        window.removeEventListener('orientationchange', this.checkScreenWidth);
        window.removeEventListener('orientationchange', this.getDrawerPadding);
        window.removeEventListener('orientationchange', this.setHeaderHeightCssVar);
    }
}
</script>